import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"
import "@fontsource/noto-sans-jp/500.css"

type PropTypes = {
  width: string
  error: boolean
  label: label
  req?: boolean
}

const FieldWrapStyles = styled.label`
  width: 100%;
  display: block;
  margin-bottom: 28px;
  input,
  textarea {
    border: 2px solid
      ${(props: any) => (props.error ? colors("red") : colors("green", "lnk"))};
    padding: 15px;
    font-family: "Raleway", sans-serif;
    font-size: 16px;
    /* height: 55px; */
    width: calc(100% - 34px);
    &,
    &:focus {
      outline: none;
    }
  }
  @media screen and (min-width: 1024px) {
    width: ${(props: any) => props.width};
  }
`

const ReqStyles = styled.span`
  color: ${colors("red")};
  margin-left: 6px;
`

const Label = styled.div`
  display: block;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${colors("blue", "xdk")};
  line-height: 1em;
  margin: 0 0 5px;
  letter-spacing: 0.25em;
`

export const SubmitGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`

const FieldWrap: React.FC = ({
  children,
  label,
  width = "100%",
  error = false,
  req,
}) => {
  return (
    <FieldWrapStyles width={width} error={error}>
      <Label>
        {label}
        {req ? <Req /> : null}
      </Label>
      {children}
    </FieldWrapStyles>
  )
}

export const Req = () => <ReqStyles>*</ReqStyles>

export default FieldWrap
